import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { CardContent, Card, Dialog } from '@material-ui/core';
import Mustache from 'react-mustache-template-component';
import moment from 'moment';
import funcTranslateHelper from '../../i18next/funcTranslateHelper';

export const useStyles = makeStyles(theme => ({
  card: {
    width: '100%',
    background: '#FFFFFF',
    boxShadow: '0 5px 28px -6px rgba(60,51,79,0.22)'
  },
  generalText: {
    fontFamily: 'Roboto-Light',
    fontSize: 16,
    color: '#6F6F6F'
  },
  mainTitle: {
    fontFamily: 'Roboto-Bold',
    fontSize: 12,
    color: '#6F6F6F',
    letterSpacing: 0.4,
    textAlign: 'left',
    marginBottom: 4,
    marginTop: 29
  },
  secondaryTitle: {
    fontFamily: 'Roboto-Bold',
    fontSize: 12,
    color: '#6F6F6F',
    letterSpacing: 0.4,
    textAlign: 'left',
    marginBottom: 4,
    marginTop: 4
  },
  hashCode: {
    fontFamily: 'Roboto-Regular',
    fontSize: 16,
    color: '#000000',
    letterSpacing: 0
  }
}));

const SuccessAssetsHistoryResult = props => {
  const classes = useStyles();
  const [fullScreen, setFullScreen] = useState(false);
  let { data: { data, template, appData } } = props;
  const { logo } = appData;

  useEffect(() => {
    if (template.includes('fullScreen')) {
      setFullScreen(true);
    }
  }, []);

  // si la plantilla tiene lastStage cogemos el ultimo estado
  if (template.includes('lastStatus')) {
    data = [data[data.length - 1]];
  }

  const mustacheData = { data: data, logo: logo };

  for (let i = 0; i < data.length; i++) {
    mustacheData.data[i].printable_tx_timeStamp = Object.assign({
      date: moment(mustacheData.data[i].tx_timeStamp, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY'),
      time: moment(mustacheData.data[i].tx_timeStamp, 'YYYY-MM-DD HH:mm:ss').format('HH:mm:ss')
    });

    mustacheData.data[i].formatedData = [];
    mustacheData.data[i].currentStage = funcTranslateHelper(mustacheData.data[i].currentStage);

    for (var prop in mustacheData.data[i]) {
      if (Object.prototype.hasOwnProperty.call(mustacheData.data[i], prop)) {
        if (
          prop !== 'printable_tx_timeStamp' &&
          prop !== 'formatedData' &&
          prop !== 'currentStage'
        ) {
          mustacheData.data[i].formatedData.push({
            key: funcTranslateHelper(prop),
            value: funcTranslateHelper(mustacheData.data[i][prop], true)
          });
        }
      }
    }
  }

  return (
    <div>
      {!fullScreen &&
        <Card className={classes.card}>
          <CardContent style={{ padding: 8, display: 'flex', justifyContent: 'center' }}>
            <Mustache sanitize={false} template={template} data={mustacheData} style={{ width: '100%', display: 'flex', justifyContent: 'center' }} />
          </CardContent>
        </Card>}
      {fullScreen &&
        <Dialog fullScreen open>

          <Mustache sanitize={false} template={template} data={mustacheData} style={{ width: '100%', display: 'flex', justifyContent: 'center' }} />
        </Dialog>}
    </div>
  );
};

export default SuccessAssetsHistoryResult;
